module.exports = __webpack_public_path__ + "img/bad.53ea1ac9.svg";